import { gql } from '@urql/core';
import React from 'react';
import { EventRegistrationFragment, EventTicketRegistrationsFragment } from '../../../generated/spin-graphql';
import { isWithinRegistrationRange } from '../../../shared/shared.utils';

import { EventTickets } from './EventTickets';

type Props = {
    eventData: EventRegistrationFragment;
    ticketRegistrations: EventTicketRegistrationsFragment;
};

gql`
    fragment EventRegistration on espin_event {
        prize
        registration_disclaimer
        register_end_date
        register_start_date
        event_tickets {
            ...EventTickets
        }
    }

    fragment EventTicketRegistrations on espin_event {
        ...TicketRegistrations
    }
`;

export const EventRegistration: React.FC<Props> = ({ eventData, ticketRegistrations }) => {
    return (
        <div className={`event-registration-card${eventData.prize <= 0 ? ' no-prize' : ''}`}>
            <h2 className="title">Register Now</h2>
            <EventTickets
                tickets={eventData.event_tickets}
                ticketRegistrations={ticketRegistrations}
                withinRegistrationRange={isWithinRegistrationRange(
                    eventData.register_start_date,
                    eventData.register_end_date,
                )}
            />
            {eventData.registration_disclaimer && (
                <p className="event-disclaimer">{eventData.registration_disclaimer}</p>
            )}
            {/* {eventData.sponsors && <EventSponsorsCard sponsors={eventData.sponsors} logoPosition={'left'} />} */}
        </div>
    );
};
